<template>
    <div class="bs-page-title">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.bs-page-title {
    font-size: 1.125rem;
    font-weight: 700;
}
</style>